/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generating_For_FreeInputs */

const en_generating_for_free = /** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating your free access...`)
};

const es_generating_for_free = /** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando tu acceso gratuito...`)
};

const fr_generating_for_free = /** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génération de votre accès gratuit...`)
};

const de_generating_for_free = /** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein kostenloser Zugang wird generiert...`)
};

const id_generating_for_free = /** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membuat akses gratis Anda...`)
};

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const ja_generating_for_free = en_generating_for_free;

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const zh_generating_for_free = en_generating_for_free;

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const ar_generating_for_free = en_generating_for_free;

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const it_generating_for_free = en_generating_for_free;

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const ru_generating_for_free = en_generating_for_free;

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const pt_generating_for_free = en_generating_for_free;

/** @type {(inputs: Generating_For_FreeInputs) => LocalizedString} */
const ko_generating_for_free = en_generating_for_free;

/**
* | output |
* | --- |
* | "Generating your free access..." |
*
* @param {Generating_For_FreeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const generating_for_free = /** @type {((inputs?: Generating_For_FreeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generating_For_FreeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_generating_for_free(inputs)
	if (locale === "es") return es_generating_for_free(inputs)
	if (locale === "fr") return fr_generating_for_free(inputs)
	if (locale === "de") return de_generating_for_free(inputs)
	if (locale === "ja") return ja_generating_for_free(inputs)
	if (locale === "zh") return zh_generating_for_free(inputs)
	if (locale === "ar") return ar_generating_for_free(inputs)
	if (locale === "id") return id_generating_for_free(inputs)
	if (locale === "it") return it_generating_for_free(inputs)
	if (locale === "ru") return ru_generating_for_free(inputs)
	if (locale === "pt") return pt_generating_for_free(inputs)
	return ko_generating_for_free(inputs)
});